/**
 * Insert a Cloudinary transformation into an existing secure delivery URL.
 * Works for both the raw cloudinary.com host and a CDN rewrite that keeps the
 * `/image/upload/` path segment.
 *
 * Example:
 *   cloudinaryTransform(
 *     "https://res.cloudinary.com/demo/image/upload/v123/foo.jpg",
 *     "w_240,h_240,c_fill,q_auto,f_auto"
 *   )
 *   // => "https://res.cloudinary.com/demo/image/upload/w_240,h_240,c_fill,q_auto,f_auto/v123/foo.jpg"
 */
export function cloudinaryTransform(url, transform) {
  if (!url || typeof url !== "string") return url;
  if (!transform) return url;
  const marker = "/upload/";
  const idx = url.indexOf(marker);
  if (idx === -1) return url;
  const head = url.slice(0, idx + marker.length);
  const tail = url.slice(idx + marker.length);
  return `${head}${transform}/${tail}`;
}

export const PORTFOLIO_THUMB_TRANSFORM = "w_240,h_240,c_fill,q_auto,f_auto";
export const PORTFOLIO_EDIT_THUMB_TRANSFORM = "w_120,h_120,c_fill,q_auto,f_auto";
